export const AGENT_STATUS = Object.freeze({
  ACTIVE: 'active',
  RESIGNED: 'resigned',
  LICENSE_EXPIRED: 'license_expired',
  NO_PERFORMANCE: 'no_performance',
});

export const AGENT_STATUS_OPTIONS = [
  { value: AGENT_STATUS.ACTIVE, label: 'มีผลบังคับตามปกติ' },
  { value: AGENT_STATUS.RESIGNED, label: 'สิ้นผล เนื่องจากลาออก' },
  { value: AGENT_STATUS.LICENSE_EXPIRED, label: 'สิ้นผล เนื่องจากใบอนุญาตขาดอายุ' },
  { value: AGENT_STATUS.NO_PERFORMANCE, label: 'สิ้นผล เนื่องจากไม่มีผลงาน' },
];

export const AGENT_STATUS_STYLES = {
  [AGENT_STATUS.ACTIVE]: {
    badge: 'bg-emerald-100 text-emerald-800',
    border: 'border-emerald-400',
  },
  [AGENT_STATUS.RESIGNED]: {
    badge: 'bg-red-100 text-red-800',
    border: 'border-red-400',
  },
  [AGENT_STATUS.LICENSE_EXPIRED]: {
    badge: 'bg-orange-100 text-orange-800',
    border: 'border-orange-400',
  },
  [AGENT_STATUS.NO_PERFORMANCE]: {
    badge: 'bg-slate-200 text-slate-700',
    border: 'border-slate-400',
  },
};

export function normalizeAgentStatus(value) {
  const status = String(value ?? '').trim().toLowerCase();
  if (AGENT_STATUS_OPTIONS.some((option) => option.value === status)) return status;
  if (status.includes('ลาออก') || status.includes('resign')) return AGENT_STATUS.RESIGNED;
  if (
    (status.includes('ใบอนุญาต') && (status.includes('ขาดอายุ') || status.includes('หมดอายุ'))) ||
    status.includes('license expired')
  ) return AGENT_STATUS.LICENSE_EXPIRED;
  if (status.includes('ไม่มีผลงาน') || status.includes('no performance')) return AGENT_STATUS.NO_PERFORMANCE;
  return AGENT_STATUS.ACTIVE;
}

export function getAgentStatusMeta(value) {
  const status = normalizeAgentStatus(value);
  const option = AGENT_STATUS_OPTIONS.find((item) => item.value === status);
  return { status, label: option.label, ...AGENT_STATUS_STYLES[status] };
}
